import axios from "axios";
import { logUtil as logger } from "@repo/lib-common";
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace httpUtil {
    export type HttpResponseCallbackFunction = (response: object) => void;
    export type HttpErrorCallbackFunction = (error: object) => void;

    export enum ContentTypeEnum {
        json = "application/json",
        formUrlEncoded = "application/x-www-form-urlencoded"
    }

    export function httpPost({ url, data, contentType = ContentTypeEnum.json, responseCallBack, errorCallBack }: {
        url: string,
        data: object,
        contentType?: ContentTypeEnum,
        responseCallBack?: HttpResponseCallbackFunction,
        errorCallBack?: HttpErrorCallbackFunction
    }) {
        logger.consoleLog("http request started", url, contentType, data)
        axios.post(url, data,
            { headers: { 'content-type': contentType } }
        ).then((response) => {
            logger.consoleLog(data, "=> response =>", response);
            if (responseCallBack) {
                responseCallBack(response);
            }
        }).catch(error => {
            logger.consoleLog(error);
            if (errorCallBack) {
                errorCallBack(error);
            }
        });

    }

    export function httpPostPromise({ url, data, contentType = ContentTypeEnum.json }: {
        url: string,
        data: object,
        contentType?: ContentTypeEnum
    }) {
        logger.consoleLog("http request started", url, contentType, data)
        return axios.post(url, data,
            { headers: { 'content-type': contentType } }
        );
    }

    export function httpGet({ url, data, contentType = ContentTypeEnum.json, responseCallBack, errorCallBack }: {
        url: string,
        data: object,
        contentType?: ContentTypeEnum,
        responseCallBack?: HttpResponseCallbackFunction,
        errorCallBack?: HttpResponseCallbackFunction
    }) {
        logger.consoleLog("http request started", url, contentType, data)
        axios.get(url,
            { headers: { 'content-type': contentType } }
        ).then((response) => {
            logger.consoleLog(data, "=> response =>", response);
            if (responseCallBack) {
                responseCallBack(response);
            }
        }).catch(error => {
            logger.consoleLog(error);
            if (errorCallBack) {
                errorCallBack(error);
            }
        });
    }

}